import { Popover, PopoverHeaderProps } from 'react-bootstrap';
import { BsPrefixRefForwardingComponent } from 'react-bootstrap/esm/helpers';

const Header: BsPrefixRefForwardingComponent<'div', PopoverHeaderProps> = (props) => (
  <Popover.Header className="pt-4 pb-0" {...props} />
);

export default Header;
